import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box, Button, Column, Popover, TextField } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { FilterChip } from '../FilterChip/FilterChip';
import { currentValue, labelFromPredicate, nextPredicate } from './StringMatchChip.utils';
export const StringMatchChip = (param)=>{
    let { testId, predicate, onChange, labels, biNames, popoverTestIds } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const [anchorEl, setAnchorEl] = useState(null);
    const [draftValue, setDraftValue] = useState(currentValue(predicate));
    const openPopover = (event)=>{
        setDraftValue(currentValue(predicate));
        setAnchorEl(event.currentTarget);
    };
    const closePopover = ()=>setAnchorEl(null);
    const apply = ()=>{
        const trimmed = draftValue.trim();
        onChange(trimmed.length === 0 ? undefined : nextPredicate(trimmed, predicate));
        closePopover();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FilterChip, {
                testId: testId,
                fieldLabel: "",
                valueLabel: labelFromPredicate(predicate, labels),
                onValueClick: openPopover,
                onRemove: ()=>onChange(undefined),
                removeBiName: biNames.remove
            }),
            /*#__PURE__*/ _jsx(Popover, {
                testId: popoverTestIds.EditPopover,
                open: anchorEl != null,
                anchorEl: anchorEl,
                onClose: closePopover,
                children: /*#__PURE__*/ _jsx(Box, {
                    padding: 12,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            /*#__PURE__*/ _jsx(TextField, {
                                testId: popoverTestIds.EditTextField,
                                bi: {
                                    name: biNames.edit
                                },
                                value: draftValue,
                                onChange: (event)=>setDraftValue(event.target.value),
                                inputProps: {
                                    onKeyDown: (event)=>{
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            apply();
                                        }
                                    }
                                },
                                autoFocus: true
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                testId: popoverTestIds.ApplyButton,
                                bi: {
                                    name: biNames.apply
                                },
                                onClick: apply,
                                children: t.applyButton()
                            })
                        ]
                    })
                })
            })
        ]
    });
};
